import React, { useEffect, useContext, useState, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../../showTost';
import { GoogleMap, OverlayView, useLoadScript } from '@react-google-maps/api';
import BickLogo from "../../Image/riderimage.png";
import { Link, useNavigate } from 'react-router-dom';
import EmptyOrderImg from "../../Image/emptyOrder.png";
const Orders = () => {

    const { BaseUrl, MapKey } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [orderList, setOrderList] = useState([]);
    const [apiloading, setApiLoading] = useState(false);
    const [isdetails, setIsDetails] = useState(false);
    const [orderinfo, setOrderInfo] = useState("");
    const [tarkingdetails, setTrakingDetails] = useState("");
    const [istraking, setIsTraking] = useState(false);
    const [progresswidth, setProgressWidth] = useState(0);
    const [canceltime, setCancelTime] = useState("");
    const [trakloading, setTrakLoading] = useState("");
    const [page, setPage] = useState(1);


    const navigate = useNavigate();

    const hasReachedBottom = useRef(false);
    const NoMoreDataRef = useRef(true);

    const currency = secureLocalStorage.getItem("currency");

    const BgGradient = orderinfo?.o_status === "Pending" ? "gradient_pending" : orderinfo?.o_status === "Processing" ? "gradient_Processing" : orderinfo?.o_status === "On Route" ? "gradient_OnRoute" : orderinfo?.o_status === "Completed" && "gradient_complit";
    const TextColor = orderinfo?.o_status === "Pending" ? "text-yellow-500" : orderinfo?.o_status === "Processing" ? "text-blue-500" : orderinfo?.o_status === "On Route" ? "text-[#03A9F4]" : orderinfo?.o_status === "Completed" && "text-[#22C55E]";
    const Icon = (orderinfo?.o_status === "Pending" || orderinfo?.o_status === "Processing") ?
        <div className={`${orderinfo?.o_status === "Pending" ? "bg-yellow-500" : "bg-blue-500"} rounded-full p-[2px]`}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12Z" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.7099 15.18L12.6099 13.33C12.0699 13.01 11.6299 12.24 11.6299 11.61V7.51001" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
        : orderinfo?.o_status === "Completed" ?
            <div className="bg-[#22C55E] rounded-full p-[2px]">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18C8.999 18 8.998 18 8.996 18C8.729 17.999 8.47499 17.892 8.28799 17.702L4.288 13.64C3.9 13.246 3.905 12.613 4.299 12.226C4.693 11.839 5.325 11.843 5.713 12.237L9.006 15.581L18.294 6.29398C18.685 5.90298 19.317 5.90298 19.708 6.29398C20.099 6.68398 20.099 7.31798 19.708 7.70798L9.70799 17.708C9.51999 17.895 9.265 18 9 18Z" fill="white" />
                </svg>
            </div>
            : <div className="bg-[#03A9F4] rounded-full p-[2px]">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.20976 13.3961L5.50729 12.1619C3.49757 11.492 3.49757 8.64932 5.50729 7.97942L17.0947 4.11693C18.818 3.5425 20.4575 5.18198 19.8831 6.90526L16.0206 18.4927C15.3507 20.5024 12.508 20.5024 11.8381 18.4927L10.6039 14.7902C10.3845 14.132 9.868 13.6155 9.20976 13.3961Z" fill="white" />
                </svg>
            </div>;


    useEffect(() => {
        handleFetchData(1);
        const TrakingId = secureLocalStorage.getItem("trakingid");
        if (TrakingId) {
            handleTrackOrder(TrakingId);
        }
    }, []);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: MapKey
    });

    const handleFetchData = (page) => {
        const uid = secureLocalStorage.getItem("Userid");
        if (uid) {

            axios.post(`${BaseUrl}/eapi/e_order_history.php`, { uid, page })
                .then((res) => {
                    console.log("e_order_history.php", res.data.OrderHistory);
                    const OrderHistory = res.data.OrderHistory;

                    if (OrderHistory.length === 0) {
                        NoMoreDataRef.current = false;
                    }
                    if (page === 1) {
                        setOrderList(OrderHistory);
                    } else {
                        setOrderList(prev => [...prev, ...OrderHistory]);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("e_order_history.php", error);
                });
        } else {
            navigate("/");
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const clientHeight = window.innerHeight;

            const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
                hasReachedBottom.current = true;
                setPage(prev => prev + 1);

            } else if (!isAtBottom && hasReachedBottom.current) {
                hasReachedBottom.current = false;
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;
        handleFetchData(page);
    }, [page]);

    const handleGetOrderDetails = (orderid) => {
        setIsDetails(true);
        setApiLoading(true);
        axios.post(`${BaseUrl}/eapi/e_order_information.php`, { orderid })
            .then((res) => {
                console.log("e_order_information.php", res.data);
                setOrderInfo(res.data.OrderInfo);
                setApiLoading(false);
            })
            .catch((error) => {
                console.error("e_order_information.php", error);
            });
    }

    const handleGetTotalItem = () => {
        const ItemQty = orderinfo?.order_items.map(item => {
            const match = item.item_name.match(/^(.*)\s+x\s+(\d+)$/);
            return match[2];
        });

        const TotalItem = ItemQty.reduce((sum, item) => sum + Number(item), 0);
        return `${TotalItem} Item`;
    }

    const handleTrackOrder = (orderid) => {
        setTrakLoading(orderid);
        axios.post(`${BaseUrl}/eapi/e_map_info.php`, { orderid })
            .then((res) => {
                // console.log("e_map_info.php", res.data.Mapinfo);
                setTrakingDetails(res.data.Mapinfo);
                setIsTraking(true);
                setCancelTime(res.data.Mapinfo.order_arrive_seconds);
                if (res.data.Mapinfo.order_arrive_seconds <= 30) {
                    setProgressWidth((100 / 29) * res.data.Mapinfo.order_arrive_seconds);
                }
                setTrakLoading("");
                secureLocalStorage.removeItem("trakingid");
            })
            .catch((error) => {
                console.error("e_map_info.php", error);
            });
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setCancelTime(prevSeconds => prevSeconds + 1);
            setProgressWidth(prev => prev + (100 / 29));
        }, 1000);
        return () => clearInterval(interval);
    }, [progresswidth]);

    const handleCloseModel = () => {
        setIsTraking(false);
        setProgressWidth(1);
    }

    const handleCancelOrder = () => {
        const uid = secureLocalStorage.getItem("Userid");
        axios.post(`${BaseUrl}/eapi/e_order_cancle.php`, { uid, order_id: tarkingdetails?.orderid.slice(7) })
            .then((res) => {
                // console.log("e_order_cancle.php", res.data);
                const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: Toastid });
                if (res.data.ResponseCode === "200") {
                    handleFetchData(1);
                    setIsTraking(false);
                }
            })
            .catch((error) => {
                console.error("e_order_cancle.php", error);
            });
    }

    const handleRefresPage = (orderid) => {
        handleCloseModel();
        handleFetchData(1);
        handleTrackOrder(orderid.slice(7));
    }

    return (
        <div>
            {loading
                ? <div className="w-full h-[calc(100vh-100px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                : <div className="order_page">
                    <div className="width_container">
                        <div className="leading-8">
                            <h1 className="title">Orders</h1>
                            <p className="font-[500] text-[17px] text-gray-600">You added {orderList?.length} items to orders</p>
                        </div>
                        <div className="flex flex-wrap items-stretch gap-[10px] mt-[20px]">
                            {orderList?.length >= 1
                                ? orderList.map((item) => {
                                    return <OrderItem key={item.order_id} trakloading={trakloading} BaseUrl={BaseUrl} item={item} handleGetOrderDetails={handleGetOrderDetails} handleFetchData={handleFetchData} currency={currency} handleTrackOrder={handleTrackOrder} />
                                })
                                : <div className="w-full flex items-center justify-center">
                                    <div className="text-center mt-[20px]">
                                        <div className="mx-auto w-[100px] rounded-full h-[100px] bg-orange-100 flex items-center justify-center">
                                            <img src={EmptyOrderImg} className='w-[60px]' alt="EmptyOrderImg" />
                                        </div>
                                        <h1 className='font-bold text-[22px] mt-[15px]'>No orders yet</h1>
                                        <p className='font-medium text-gray-600 leading-5 mt-[10px] mb-6'>Please explore and place a food order first, <br /> your order will appear here later.</p>
                                        <Link to="/" className='bg-[#FF8D28] text-white px-[20px] py-[8px] rounded-full font-medium'>Explore food</Link>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            {isdetails && <div onClick={() => setIsDetails(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="bg-[#f1f2f4] w-[500px] flex flex-col max-h-[90vh] rounded-[15px] scroll_container pb-[10px]">
                    {apiloading
                        ? <div className="h-[50vh] flex items-center justify-center">
                            <div className="loader"></div>
                        </div>
                        : <div className="">
                            <div className="px-[10px] py-[10px] bg-white border-b-[1px] sticky top-0">
                                <div className="flex items-center gap-[10px]">
                                    <button onClick={() => setIsDetails(false)}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.7501 12C20.7501 12.414 20.4141 12.75 20.0001 12.75H5.81115L8.53112 15.47C8.82412 15.763 8.82412 16.238 8.53112 16.531C8.38512 16.677 8.19309 16.751 8.00109 16.751C7.80909 16.751 7.61706 16.678 7.47106 16.531L3.47106 12.531C3.40206 12.462 3.3472 12.3791 3.3092 12.2871C3.2332 12.1041 3.2332 11.8971 3.3092 11.7141C3.3472 11.6221 3.40206 11.539 3.47106 11.47L7.47106 7.46999C7.76406 7.17699 8.2391 7.17699 8.5321 7.46999C8.8251 7.76299 8.8251 8.23803 8.5321 8.53103L5.81213 11.251H20.0001C20.4141 11.25 20.7501 11.586 20.7501 12Z" fill="#25314C" />
                                        </svg>
                                    </button>
                                    <div className="leading-4">
                                        <h1 className="text-[15px] font-[500]">ORDER #{orderinfo?.order_id}</h1>
                                        <p className="text-[14px] text-gray-500 font-[500]">{orderinfo?.o_status} | {orderinfo?.order_complete_date ? orderinfo?.order_complete_date : handleGetTotalItem()}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white flex items-center gap-[5px] overflow-hidden px-[10px] py-[5px] rounded-b-[10px]">
                                <div className="flex flex-col items-center">
                                    <div className="bg-[--bgcolor] w-[12px] h-[12px] rounded-full flex items-center justify-center">
                                        <div className="bg-white p-[3px] rounded-full"></div>
                                    </div>
                                    <div className="w-[2px] h-[24px] bg-[--bgcolor]"></div>
                                    <div className="bg-[--bgcolor] w-[12px] h-[12px] rounded-full flex items-center justify-center">
                                        <div className="bg-white p-[3px] rounded-full"></div>
                                    </div>
                                </div>
                                <div className="flex flex-col items-start gap-[4px] overflow-hidden">
                                    <div className="w-full flex items-center gap-[5px]">
                                        <span>•</span>
                                        <div className="leading-4 overflow-hidden">
                                            <h1 className="text-[14px] font-[500] whitespace-nowrap overflow-ellipsis overflow-hidden">{orderinfo?.rest_name}</h1>
                                            <p className="whitespace-nowrap overflow-ellipsis overflow-hidden text-[14px] text-gray-500 font-[500]">{orderinfo?.rest_address}</p>
                                        </div>
                                    </div>
                                    <div className="w-full flex items-center gap-[5px] overflow-hidden">
                                        <span>•</span>
                                        <div className="leading-4 overflow-hidden">
                                            <h1 className="text-[14px] font-[500] whitespace-nowrap overflow-ellipsis overflow-hidden">{orderinfo?.address_type}</h1>
                                            <p className="whitespace-nowrap overflow-ellipsis overflow-hidden text-[14px] text-gray-500 font-[500]">{orderinfo?.cust_address}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <h1 className='py-[5px] px-[10px] font-[500] text-gray-700 text-[15px]'>ITEM DETAILS</h1>
                                <div className={`mx-[10px] bg-white p-[10px] rounded-[10px] ${BgGradient}`}>
                                    <div className="mb-[5px] flex items-center justify-between">
                                        <div>
                                            <h1 className="font-[600]">Delivery</h1>
                                            <p className="text-[14px] font-[600] text-gray-500">{orderinfo?.order_items.length} items {orderinfo?.rest_landmark && <span>• Landmark</span>}</p>
                                        </div>
                                        <div className="flex items-center gap-[5px]">
                                            <span>{Icon}</span>
                                            <span className={`font-[500] ${TextColor}`}>{orderinfo?.o_status}</span>
                                        </div>
                                    </div>
                                    <div className="border-t-[2px] border-dashed pt-[5px]">
                                        {orderinfo?.order_items.map((item, index) => {
                                            const match = item.item_name.match(/^(.*)\s+x\s+(\d+)$/);
                                            return <div key={index} className="py-[2px]">
                                                <div className="flex items-center justify-between gap-[10px] font-[500]">
                                                    <p className="text-[14px] text-gray-800 whitespace-nowrap overflow-hidden overflow-ellipsis">{match[2]}x {match[1].trim()}</p>
                                                    <span className="text-[14px] text-gray-800">{currency + item.item_total}</span>
                                                </div>
                                                {item.item_addon && item.item_addon.split(",").map((addon, index) => {
                                                    return <p key={index} className="text-[14px] text-gray-800 ps-[5px]" >• {addon}</p>
                                                })}
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>

                            {orderinfo?.o_status === "Completed" && <div className="">
                                <h1 className='py-[5px] px-[10px] font-[500] text-gray-700 text-[15px]'>RIDER DETAILS</h1>
                                <div className="mx-[10px] text-[rgba(2,6,12,.7)] bg-white p-[10px] rounded-[10px]">
                                    <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1 className="">Rider Name</h1>
                                        <span>{orderinfo?.rider_name}</span>
                                    </div>
                                    {orderinfo?.rider_tip !== "0" && <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1 className="">Rider Tip</h1>
                                        <span>{currency + orderinfo?.rider_tip}</span>
                                    </div>}
                                </div>
                            </div>}

                            <div className="">
                                <h1 className='py-[5px] px-[10px] font-[500] text-gray-700 text-[15px]'>TOTAL ORDER BILL DETAILS</h1>
                                <div className="mx-[10px] text-[rgba(2,6,12,.7)] bg-white p-[10px] rounded-[10px]">
                                    <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1 className="">Item Bill</h1>
                                        <span>{currency + orderinfo?.subtotal}</span>
                                    </div>
                                    <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1 className="">Delivery Fee</h1>
                                        <span>{currency + orderinfo?.delivery_charge}</span>
                                    </div>
                                    <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1>Restaurent Charges</h1>
                                        <span>{currency + orderinfo?.rest_charge}</span>
                                    </div>
                                    <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1>Taxes and Charges</h1>
                                        <span>{currency + (orderinfo?.subtotal / orderinfo?.tax).toFixed(0)}</span>
                                    </div>
                                    {orderinfo?.wall_amt !== "0" && <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1>Wallet Amount</h1>
                                        <span className="text-green-600">-{currency + orderinfo?.wall_amt}</span>
                                    </div>}
                                    {orderinfo?.cou_amt !== "0" && <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1>Coupon Amount</h1>
                                        <span className="text-green-600">-{currency + orderinfo?.cou_amt}</span>
                                    </div>}
                                    <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1>Payment Method</h1>
                                        <span>{orderinfo?.p_method_name}</span>
                                    </div>
                                    {orderinfo?.trans_id != "0" && <div className="text-[14px] font-[500] flex items-center justify-between pt-[2px]">
                                        <h1>Transction id</h1>
                                        <span>{orderinfo?.trans_id}</span>
                                    </div>}

                                    <div className="border-t-[1px] mt-[10px]"></div>

                                    <div className="text-[14px] text-black font-[500] flex items-center justify-between pt-[10px]">
                                        <h1>Grand Total</h1>
                                        <span>{currency + orderinfo?.order_total}</span>
                                    </div>

                                </div>
                            </div>
                        </div>}
                </div>
            </div>}

            {
                istraking && <div onClick={handleCloseModel} className="model items-center">
                    <div onClick={(e) => e.stopPropagation()} className="traking_box scroll_container">
                        <div className="sticky top-0 z-[888] bg-white flex items-center justify-between gap-[15px] py-[10px] px-[20px]">
                            <div className="flex items-center gap-[10px]">
                                <button onClick={handleCloseModel}>
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="black" />
                                    </svg>
                                </button>
                                <div className="leading-5">
                                    <h1 className="font-[700] text-[17px]">{tarkingdetails?.orderid}</h1>
                                    <p className="text-[15px] font-[500] text-gray-600">{tarkingdetails?.arrive_time}</p>
                                </div>
                            </div>
                            <button onClick={() => handleRefresPage(tarkingdetails?.orderid)} className='box_shadow rounded-full'>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.686 13.0811C21.148 18.0231 16.984 21.75 12 21.75C8.603 21.75 5.504 19.979 3.75 17.186V20C3.75 20.414 3.414 20.75 3 20.75C2.586 20.75 2.25 20.414 2.25 20V15C2.25 14.586 2.586 14.25 3 14.25H8C8.414 14.25 8.75 14.586 8.75 15C8.75 15.414 8.414 15.75 8 15.75H4.66992C6.05992 18.476 8.877 20.25 12 20.25C16.217 20.25 19.7391 17.0979 20.1951 12.9189C20.2391 12.5059 20.613 12.2109 21.021 12.2539C21.434 12.2989 21.73 12.6691 21.686 13.0811ZM21 3.25C20.586 3.25 20.25 3.586 20.25 4V6.81396C18.496 4.02096 15.397 2.25 12 2.25C7.017 2.25 2.85296 5.97695 2.31396 10.9189C2.26896 11.3309 2.56603 11.7011 2.97803 11.7461C3.00503 11.7491 3.03306 11.75 3.06006 11.75C3.43806 11.75 3.76296 11.4651 3.80396 11.0811C4.25996 6.90205 7.78302 3.75 11.999 3.75C15.123 3.75 17.9391 5.524 19.3291 8.25H16C15.586 8.25 15.25 8.586 15.25 9C15.25 9.414 15.586 9.75 16 9.75H21C21.414 9.75 21.75 9.414 21.75 9V4C21.75 3.586 21.414 3.25 21 3.25Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>

                        <div className="">
                            {isLoaded && <MapComponent tarkingdetails={tarkingdetails} BaseUrl={BaseUrl} />}
                        </div>

                        {tarkingdetails?.order_step !== 3 && <div className="p-[20px]">
                            <div className="border-[1px] border-gray-300 rounded-[16px]">
                                <div className="flex items-center gap-[10px] justify-between p-[15px]">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={`${BaseUrl}/${tarkingdetails?.rest_img}`} className="w-[50px] h-[50px] object-cover rounded-[5px]" alt="" />
                                        <div className="">
                                            <h1 className="text-[17px] font-[600]">{tarkingdetails?.rest_name}</h1>
                                            <p className="text-[15px] font-[500] text-gray-500">{tarkingdetails?.rest_msg || tarkingdetails?.rider_msg}</p>
                                        </div>
                                    </div>
                                    {tarkingdetails?.order_step === 1 && <button className="text-[17px] font-[600] text-[--bgcolor] bg-[#e9ecee] px-[30px] py-[2px] rounded-[50px]">Call</button>}
                                </div>
                                <div className="border-t-[1px]"></div>
                                {tarkingdetails?.order_step === 1 && (canceltime < 30
                                    ? <div className="flex items-center gap-[10px] justify-between p-[15px]">
                                        <button onClick={handleCancelOrder} className="text-[17px] font-[600] text-[--bgcolor] rounded-[50px]">Cancel Order</button>
                                        <div className="w-[250px]">
                                            <div className="w-full bg-[#e0e0e0] rounded-[50px] overflow-hidden">
                                                <div className="h-[15px] rounded-[50px] bg-[--bgcolor]" style={{ width: `${progresswidth}%`, transition: 'width 1.30s ease-out' }} />
                                            </div>
                                        </div>
                                    </div>
                                    : <div className="flex items-center gap-[10px] p-[15px]">
                                        <div className="border-[1px] border-gray-300 p-[12px] rounded-[10px]">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z" fill="black" />
                                            </svg>
                                        </div>
                                        <p>We'll assign a delivery partner when your food is just about ready</p>
                                    </div>)}

                                {tarkingdetails?.order_step === 2 && <div className="p-[15px]">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={`${BaseUrl}/${tarkingdetails?.rider_img}`} className="w-[60px] h-[60px] object-cover rounded-[10px] border-[2px] " alt="rider_img" />
                                        <div className="">
                                            <h1 className="font-[500] text-[17px]">{tarkingdetails?.rider_name}</h1>
                                            <h1 className="font-[500] text-gray-500 text-[15px]">{tarkingdetails?.rider_msg}</h1>
                                        </div>
                                    </div>
                                </div>}

                            </div>
                        </div>}


                        {tarkingdetails?.order_step === 3 && <div className="p-[20px]">
                            <div className="border-[1px] border-gray-300 rounded-[16px] p-[15px]">
                                <div className="flex items-center gap-[10px]">
                                    <img src={`${BaseUrl}/${tarkingdetails?.rider_img}`} className="w-[60px] h-[60px] object-cover rounded-[10px] border-[2px] " alt="rider_img" />
                                    <div className="">
                                        <h1 className="font-[500] text-gray-800 text-[17px]">{tarkingdetails?.rider_name}</h1>
                                        <h1 className="font-[500] text-gray-800 text-[17px]">{tarkingdetails?.rider_mobile}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>}

                    </div>
                </div>
            }

        </div >
    )
}

export default Orders;

const OrderItem = ({ BaseUrl, item, handleGetOrderDetails, currency, handleTrackOrder, trakloading, handleFetchData }) => {

    const IsColor = item?.o_status === "Pending" ? "text-yellow-500" : item?.o_status === "Processing" ? "text-blue-500" : item?.o_status === "On Route" ? "text-[#03A9F4]" : item?.o_status === "Completed" && "text-[#22C55E]";
    const IsLoading = trakloading === item.order_id;

    const [isrestaurant, setIsRestaurant] = useState(false);
    const [restaurantrating, setRestaurantRating] = useState(0);
    const [restauranttext, setRestaurantText] = useState("");
    const [isdelivery, setIsDelivery] = useState(false);
    const [deliveryrating, setDeliveryRating] = useState(0);
    const [deliverytext, setDeliveryText] = useState("");
    const [apiloading, setApiLoading] = useState("");

    const handleRating = () => {
        const uid = secureLocalStorage.getItem("Userid");
        setApiLoading("Rating");
        const ApiData = {
            uid,
            orderid: item.order_id,
            rest_rate: restaurantrating || "",
            rest_text: restauranttext || "",
            rider_rate: deliveryrating || "",
            rider_text: deliverytext || "",
            type: isrestaurant ? "restaurant" : isdelivery && "rider"
        }

        axios.post(`${BaseUrl}/eapi/e_rate_update.php`, ApiData)
            .then((res) => {
                console.log("e_rate_update.php", res.data);
                const ToastId = res.data.ResponseCode === "200" ? "success" : "error";
                showToast({ title: res.data.ResponseMsg, id: ToastId });
                setIsRestaurant(false);
                setIsDelivery(false);
                setRestaurantText("");
                setDeliveryText("");
                setApiLoading("");
                handleFetchData(1);
            })
            .catch((error) => {
                console.error("e_rate_update.php", error);
            });
    }

    return (<>
        <div key={item.id} onClick={() => handleGetOrderDetails(item.order_id)} className="order_box">

            <div className="gradient_title rounded-t-[16px] py-[8px] px-[12px] flex items-satrt justify-between gap-[10px]">
                <div className="overflow-hidden">
                    <div className="leading-5 overflow-hidden">
                        <h1 className="font-[700] text-[17px] text-gray-800 whitespace-nowrap overflow-hidden overflow-ellipsis">{item.rest_name}</h1>
                        <p className="text-gray-600 font-[500] text-[15px]">{item.rest_landmark}</p>
                    </div>
                </div>
                <span className={`font-[500] text-[15px] whitespace-nowrap ${IsColor}`}>{item.o_status}</span>
            </div>

            <div className="py-[10px] mx-[12px]">
                {item?.order_items.split(",").map((product, index) => {
                    const match = product.match(/^(.*)\s+x\s+(\d+)$/);
                    if (index < 2) {
                        return <div key={index} className="flex items-center gap-[10px]">
                            <span className="whitespace-nowrap bg-gray-200 text-[13px] font-[500] px-[8px] rounded-[5px]">{match[2]} X</span>
                            <p className="whitespace-nowrap overflow-hidden overflow-ellipsis text-[15px]">{match[1].trim()}</p>
                        </div>
                    }
                })}
                {item.order_items.split(",").length > 2 && <h1 className="text-gray-500 font-[500] inline-block border-b text-[13px] mt-[5px]">& {item.order_items.split(",").length - 2} More</h1>}
            </div>

            <div>
                {item?.o_status === "Completed" && <div className="py-[8px] mx-[12px] border-t-[1px] flex items-center justify-between gap-[20px]">
                    <div className="w-full">
                        <h1 className="font-[500] text-[14px] text-gray-500">Restaurant Rating</h1>
                        {item.rest_rate === "0"
                            ? <button onClick={(e) => { e.stopPropagation(); setIsRestaurant(true); setRestaurantRating(1); }} className="w-full bg-blue-100 py-[5px] text-blue-700 font-[600] rounded-[5px] mt-[5px]">Review</button>
                            : <div className="flex items-center justify-start mt-[5px]">
                                {[1, 2, 3, 4, 5].map((star) => {
                                    return <div key={star} className={`cursor-pointer ${item.rest_rate >= star ? "text-[--bgcolor]" : "text-gray-300"}`}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                })}
                            </div>
                        }
                    </div>
                    <div className="h-[40px] w-[2px] bg-gray-400"></div>
                    <div className="w-full">
                        <h1 className="font-[500] text-[14px] text-gray-500">Delivery Rating</h1>
                        {item.rider_rate === "0" ?
                            <button onClick={(e) => { e.stopPropagation(); setIsDelivery(true); setDeliveryRating(1); }} className="w-full bg-blue-100 py-[5px] text-blue-700 font-[600] rounded-[5px] mt-[5px]">Review</button>
                            : <div className="flex items-center justify-start mt-[5px]">
                                {[1, 2, 3, 4, 5].map((star) => {
                                    return <div key={star} className={`cursor-pointer ${item.rider_rate >= star ? "text-[--bgcolor]" : "text-gray-300"}`}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                })}
                            </div>}
                    </div>
                </div>}

                <div className={`mx-[12px] ${item?.o_status !== "Completed" ? "pt-[10px] border-t-[1px]" : ""}`}>
                    {item?.o_status !== "Completed" && <button onClick={(e) => { e.stopPropagation(); handleTrackOrder(item.order_id); }} className={`w-full text-orange-500 font-[500] text-[16px] bg-[#f9741627] py-[8px] rounded-[10px]`}>
                        {IsLoading
                            ? <div style={{ width: "25px", height: "25px" }} className="loader mx-auto"></div>
                            : <span>Track order</span>}
                    </button>}

                    <div className="mt-[5px] text-gray-500 text-[14px] font-[500]">
                        <p>• Bill Total : <span className="text-gray-800">{currency + item.order_total}</span> </p>
                        {item.order_complete_date && <p>• Ordered : <span className="text-gray-800">{item.order_complete_date}</span> </p>}
                    </div>
                </div>
            </div>

        </div >

        {isrestaurant && <div onClick={() => { setIsRestaurant(false); setRestaurantRating(0); }} className="model items-center">
            <div onClick={(e) => e.stopPropagation()} className="bg-white px-[20px] pt-[15px] pb-[15px] rounded-[16px] w-[400px]">
                <div className="mb-[10px] flex items-center gap-[10px]">
                    <button onClick={() => { setIsRestaurant(false); setRestaurantRating(0); }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="black" />
                        </svg>
                    </button>
                    <h1 className="font-[500] text-[17px]">Restaurant Rating</h1>
                </div>
                <div className="flex items-center justify-center gap-[5px] mb-[20px]">
                    {[1, 2, 3, 4, 5].map((item) => {
                        return <div key={item} onClick={(e) => { e.stopPropagation(); setRestaurantRating(item); setIsRestaurant(true); }} className={`cursor-pointer ${restaurantrating >= item ? "text-[--bgcolor]" : "text-gray-300"}`}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                            </svg>
                        </div>
                    })}
                </div>
                <textarea value={restauranttext} onChange={(e) => setRestaurantText(e.target.value)} className="w-full min-h-[150px] max-h-[150px] rounded-[10px] p-[5px] border-[2px] focus-within:outline-[--bgcolor]" placeholder="Restaurant comment..." ></textarea>
                <button onClick={handleRating} className="w-full mt-[15px] bg-[--bgcolor] text-white py-[8px] font-[700] text-[17px] rounded-[10px]">
                    {apiloading === "Rating"
                        ? <div className="mx-auto btn_loader"></div>
                        : "SUBMIT"}
                </button>
            </div>
        </div>
        }

        {isdelivery && <div onClick={() => { setIsDelivery(false); setDeliveryRating(0); }} className="model items-center">
            <div onClick={(e) => e.stopPropagation()} className="bg-white px-[20px] pt-[15px] pb-[15px] rounded-[16px] w-[400px]">
                <div className="mb-[10px] flex items-center gap-[10px]">
                    <button onClick={() => { setIsDelivery(false); setDeliveryRating(0); }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22.0001 12C22.0001 12.552 21.5531 13 21.0001 13H5.41413L10.7071 18.293C11.0981 18.684 11.0981 19.3161 10.7071 19.7071C10.5121 19.9021 10.2561 20 10.0001 20C9.74407 20 9.48804 19.9021 9.29304 19.7071L2.29401 12.708C2.20101 12.615 2.12797 12.5051 2.07697 12.3821C1.97597 12.1381 1.97597 11.862 2.07697 11.618C2.12797 11.495 2.20101 11.385 2.29401 11.292L9.29304 4.29301C9.68403 3.90201 10.3161 3.90201 10.7071 4.29301C11.0981 4.68401 11.0981 5.31607 10.7071 5.70707L5.41413 11H21.0001C21.5531 11 22.0001 11.448 22.0001 12Z" fill="black" />
                        </svg>
                    </button>
                    <h1 className="font-[500] text-[17px]">Delivery Rating</h1>
                </div>
                <div className="flex items-center justify-center gap-[5px] mb-[20px]">
                    {[1, 2, 3, 4, 5].map((item) => {
                        return <div key={item} onClick={(e) => { e.stopPropagation(); setDeliveryRating(item); setIsDelivery(true); }} className={`cursor-pointer ${deliveryrating >= item ? "text-[--bgcolor]" : "text-gray-300"}`}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                            </svg>
                        </div>
                    })}
                </div>
                <textarea value={deliverytext} onChange={(e) => setDeliveryText(e.target.value)} className="w-full min-h-[150px] max-h-[150px] rounded-[10px] p-[5px] border-[2px] focus-within:outline-[--bgcolor]" placeholder="Delivery comment..." ></textarea>
                <button onClick={handleRating} className="w-full mt-[15px] bg-[--bgcolor] text-white py-[8px] font-[700] text-[17px] rounded-[10px]">
                    {apiloading === "Rating"
                        ? <div className="mx-auto btn_loader"></div>
                        : "SUBMIT"}
                </button>
            </div>
        </div>
        }

    </>)
}


const MapComponent = ({ tarkingdetails, BaseUrl }) => {

    const [mapCenter] = useState({
        lat: Number(tarkingdetails.rest_lats),
        lng: Number(tarkingdetails.rest_longs)
    });

    const rescoords = { lat: Number(tarkingdetails.rest_lats), lng: Number(tarkingdetails.rest_longs) };
    const ridercoords = { lat: Number(tarkingdetails?.rider_lats), lng: Number(tarkingdetails?.rider_longs) };
    const custcoords = { lat: Number(tarkingdetails?.cust_address_lat), lng: Number(tarkingdetails?.cust_address_long) };

    const getBearing = (startLatLng, endLatLng) => {
        const lat1 = startLatLng.lat() * (Math.PI / 180);
        const lat2 = endLatLng.lat() * (Math.PI / 180);
        const lngDiff = (endLatLng.lng() - startLatLng.lng()) * (Math.PI / 180);

        const y = Math.sin(lngDiff) * Math.cos(lat2);
        const x = Math.cos(lat1) * Math.sin(lat2) -
            Math.sin(lat1) * Math.cos(lat2) * Math.cos(lngDiff);

        const bearing = Math.atan2(y, x) * (180 / Math.PI);
        return (bearing + 360) % 360;
    };

    const rotateIcon = (imageUrl, angle, callback) => {
        const image = new Image();
        image.src = imageUrl;

        image.onload = () => {
            const canvas = document.createElement('canvas');
            const size = 50;
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');
            ctx.translate(size / 2, size / 2);
            ctx.rotate((angle * Math.PI) / 180);
            ctx.drawImage(image, -size / 2, -size / 2, size, size);
            callback(canvas.toDataURL());
        };
    };

    const addCustomMarkers = (directionsResult, map) => {
        const route = directionsResult.routes[0];
        const leg = route.legs[0];

        const bearing = getBearing(leg.start_location, leg.end_location);

        rotateIcon(BickLogo, bearing, (rotatedIcon) => {
            new window.google.maps.Marker({
                position: leg.start_location,
                map: map,
                icon: {
                    url: rotatedIcon,
                    scaledSize: new window.google.maps.Size(45, 45),
                },
                title: tarkingdetails?.rider_name,
            });
        });
    };


    const onMapLoad = (map) => {

        if (tarkingdetails.order_step === 1) return;

        const origin = ridercoords;
        const destination = custcoords;

        const directionsService = new window.google.maps.DirectionsService();
        const directionsRenderer = new window.google.maps.DirectionsRenderer({
            map: map,
            suppressMarkers: true,
            polylineOptions: {
                strokeColor: '#ff5200',
                strokeWeight: 5,
            },
        });

        directionsService.route(
            {
                origin,
                destination,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    directionsRenderer.setDirections(result);
                    addCustomMarkers(result, map);
                } else {
                    console.error('Error fetching directions', result);
                }
            }
        );
    };


    return (
        <div className="google_map">
            <GoogleMap
                center={mapCenter}
                zoom={12}
                onLoad={onMapLoad}
                options={{
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    zoomControl: true,
                }}
            >
                {tarkingdetails.order_step === 1 && (
                    <OverlayView
                        position={rescoords}
                        mapPaneName={OverlayView.MAP_PANE}
                    >
                        <div className="w-full">
                            <div className="">
                                <div className="mappin_text">{tarkingdetails?.rest_name}</div>
                            </div>
                            <div className="absolute -top-[35px] -left-[15px] pointer-events-none">
                                <div className="custom-pin bg-[--bgcolor]">
                                    <div className="pin-image-wrapper">
                                        <img
                                            src={`${BaseUrl}/${tarkingdetails?.rest_img}`}
                                            alt="logo"
                                            className="pin-image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </OverlayView>
                )}


                {tarkingdetails.order_step !== 1 && <OverlayView
                    position={custcoords}
                    mapPaneName={OverlayView.MAP_PANE}
                >
                    <div className="">
                        <div className="absolute -top-[35px] -left-[15px] pointer-events-none">
                            <div className="custom-pin bg-[#25314C]">
                                <div className="pin-image-wrapper flex items-center justify-center">
                                    {tarkingdetails?.cust_address_type === "Home"
                                        ? <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M18 21H14.8C14.634 21 14.5 20.866 14.5 20.7V16.5C14.5 15.119 13.381 14 12 14C10.619 14 9.5 15.119 9.5 16.5V20.7C9.5 20.866 9.36595 21 9.19995 21H6C4 21 3 20 3 18V11.651C3 9.65302 3.52305 9.34608 4.43005 8.58608L10.394 3.58498C11.323 2.80598 12.6781 2.80598 13.6071 3.58498L19.571 8.58608C20.477 9.34608 21.001 9.65302 21.001 11.651V18C21 20 20 21 18 21Z" fill="white" />
                                        </svg>
                                        : <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21 20.25H19.5V6C19.5 4 18.5 3 16.5 3H7.5C5.5 3 4.5 4 4.5 6V20.25H3C2.586 20.25 2.25 20.586 2.25 21C2.25 21.414 2.586 21.75 3 21.75H21C21.414 21.75 21.75 21.414 21.75 21C21.75 20.586 21.414 20.25 21 20.25ZM14 6.25H15C15.414 6.25 15.75 6.586 15.75 7C15.75 7.414 15.414 7.75 15 7.75H14C13.586 7.75 13.25 7.414 13.25 7C13.25 6.586 13.586 6.25 14 6.25ZM14 9.25H15C15.414 9.25 15.75 9.586 15.75 10C15.75 10.414 15.414 10.75 15 10.75H14C13.586 10.75 13.25 10.414 13.25 10C13.25 9.586 13.586 9.25 14 9.25ZM14 12.25H15C15.414 12.25 15.75 12.586 15.75 13C15.75 13.414 15.414 13.75 15 13.75H14C13.586 13.75 13.25 13.414 13.25 13C13.25 12.586 13.586 12.25 14 12.25ZM9 6.25H10C10.414 6.25 10.75 6.586 10.75 7C10.75 7.414 10.414 7.75 10 7.75H9C8.586 7.75 8.25 7.414 8.25 7C8.25 6.586 8.586 6.25 9 6.25ZM9 9.25H10C10.414 9.25 10.75 9.586 10.75 10C10.75 10.414 10.414 10.75 10 10.75H9C8.586 10.75 8.25 10.414 8.25 10C8.25 9.586 8.586 9.25 9 9.25ZM9 12.25H10C10.414 12.25 10.75 12.586 10.75 13C10.75 13.414 10.414 13.75 10 13.75H9C8.586 13.75 8.25 13.414 8.25 13C8.25 12.586 8.586 12.25 9 12.25ZM9.75 17.5C9.75 16.5 10.25 16 11.25 16H12.75C13.75 16 14.25 16.5 14.25 17.5V20.25H9.75V17.5Z" fill="white" />
                                        </svg>}
                                </div>
                            </div>
                        </div>
                    </div>

                </OverlayView>}

            </GoogleMap>
        </div>
    );
};